import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Typography,
} from '@mui/material';
import React, {useState} from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import {MinusBlack, PlusBlack} from '@jobseeker/lotus/icons';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

interface FAQProps {
  faqData: {
    question: React.ReactNode;
    answer: React.ReactNode;
  }[];
}

const FAQ = ({faqData}: FAQProps) => {
  const theme = useWrappedTheme();
  const [expandedIndex, setExpandedIndex] = useState<number>(-1);

  const toggleAccordion = (index: number) => {
    if (expandedIndex === index) {
      setExpandedIndex(-1);
    } else {
      setExpandedIndex(index);
    }
  };

  return (
    <>
      <Box
        sx={{
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card
          sx={{
            width: '100%',
            margin: '0 auto',
            borderRadius: 3,
          }}
        >
          <Box
            sx={{
              width: {sx: '100%', md: '70%'},
              margin: '0 auto',
              textAlign: 'center',
            }}
          >
            <Box
              sx={{
                marginTop: {xs: 3, md: 5},
              }}
            >
              <Typography
                variant="sectionMainHeading"
                sx={{
                  marginTop: {xs: 3, md: 5},
                  marginBottom: {xs: 3, md: 5},
                  fontSize: {
                    xs: theme.typography.pxToRem(22),
                    md: theme.typography.pxToRem(42),
                  },
                }}
              >
                Frequently Asked Questions
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: 4.5,
                marginBottom: 4.5,
                marginLeft: 4,
                paddingLeft: 2.5,
                paddingRight: 2.5,
              }}
            >
              {faqData.map((faq, index) => {
                const isLastItem = index === faqData.length - 1;
                return (
                  <Accordion
                    key={index}
                    expanded={expandedIndex === index}
                    onChange={() => toggleAccordion(index)}
                    sx={{
                      border: 'none',
                      background: '#FFFFFF',
                      boxShadow: 'none',
                      paddingTop: 1.5,
                      paddingBottom: 1.5,
                      borderBottom:
                        expandedIndex === index || isLastItem
                          ? 'none'
                          : '1px solid #7E7E7E20',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        expandedIndex === index ? (
                          <Image
                            src={MinusBlack}
                            alt={'-'}
                            width={20}
                            height={12}
                          />
                        ) : (
                          <Image
                            src={PlusBlack}
                            alt={'+'}
                            width={20}
                            height={16}
                          />
                        )
                      }
                      aria-controls={`panel${index + 1}a-content`}
                      id={`panel${index + 1}a-header`}
                      sx={{
                        display: 'flex',
                        padding: '4px 16px',
                        alignItems: 'baseline',
                        border: 'none',
                        background: '#FFFFFF',
                        '& .MuiAccordionSummary-content': {
                          border: 'none',
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                          marginLeft: 'auto',
                        },
                      }}
                    >
                      <Box
                        component="div"
                        sx={{
                          minWidth: 32,
                          height: 32,
                          borderRadius: '50%',
                          backgroundColor: '#FFFFFF',
                          border: '1px solid #e7e7e7',
                          textAlign: 'center',
                          fontSize: '12px',
                          fontWeight: 400,
                          lineHeight: '32px',
                          color: '#000',
                          position: 'relative',
                          top: {xs: 0, md: '-3px'},
                          left: '-62px',
                        }}
                      >
                        {index + 1}
                      </Box>
                      <Typography
                        sx={{
                          color: '#000',
                          fontWeight: 500,
                          fontSize: theme.typography.pxToRem(16),
                          textAlign: 'left',
                          marginLeft: '-48px',
                        }}
                      >
                        {faq.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{borderBottom: 'none'}}>
                      <Typography
                        sx={{
                          fontSize: '15px',
                          textAlign: 'left',
                          color: '#000',
                          marginLeft: '-16px',
                        }}
                      >
                        {faq.answer}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Box>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default FAQ;
